import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { SizingMultiplier, Typography } from '@ocx/ui';

export const ReferralCodeAppliedAlert = () => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      borderRadius={2}
      py={SizingMultiplier.sm}
      px={SizingMultiplier.md}
      bgcolor="success.light"
      color="success.contrastText"
      role="alert">
      <Typography variant="body2">
        <FormattedMessage id="signup:referral-code-applied-alert:title" defaultMessage="Referral Code Applied!" />
      </Typography>
      <CheckCircleIcon sx={{ mr: -SizingMultiplier.sm, color: 'success.dark' }} />
    </Box>
  );
};
